import React from 'react';
import athena from '../../../../assets/images/games/m-game/percy/janus/athena.webp';
import blank from '../../../../assets/images/games/m-game/percy/janus/blank.webp';
import lyre from '../../../../assets/images/games/m-game/percy/janus/lyre.webp';
import poseidon from '../../../../assets/images/games/m-game/percy/janus/poseidon.webp';
import zeus from '../../../../assets/images/games/m-game/percy/janus/zeus.webp';

export default function MJanusCipher() {
    return (
        <React.Fragment>
            <div className="m-janus">
                <div className="m-janus-wrapper">
                    <div className="m-janus-row">
                        <img src={athena} alt="1" />
                        <img src={lyre} alt="1" />
                        <img src={poseidon} alt="1" />
                        <img src={zeus} alt="1" />
                    </div>
                    <div className="m-janus-row">
                        <img src={poseidon} alt="1" />
                        <img src={zeus} alt="1" />
                        <img src={athena} alt="1" />
                        <img src={lyre} alt="1" />
                    </div>
                    <div className="m-janus-row">
                        <img src={zeus} alt="1" />
                        <img src={athena} alt="1" />
                        <img src={lyre} alt="1" />
                        <img src={poseidon} alt="1" />
                    </div>
                    <div className="m-janus-row">
                        <img src={blank} alt="1" />
                        <img src={blank} alt="1" />
                        <img src={blank} alt="1" />
                        <img src={blank} alt="1" />
                    </div>
                </div>

                <div className="m-janus__option-label">a)</div>
                <div className="m-janus-wrapper">
                    <div className="m-janus-row">
                        <img src={poseidon} alt="1" />
                        <img src={zeus} alt="1" />
                        <img src={lyre} alt="1" />
                        <img src={athena} alt="1" />
                    </div>
                </div>
                <div className="m-janus__option-label">b)</div>
                <div className="m-janus-wrapper">
                    <div className="m-janus-row">
                        <img src={athena} alt="1" />
                        <img src={zeus} alt="1" />
                        <img src={poseidon} alt="1" />
                        <img src={lyre} alt="1" />
                    </div>
                </div>
                <div className="m-janus__option-label">c)</div>
                <div className="m-janus-wrapper">
                    <div className="m-janus-row">
                        <img src={lyre} alt="1" />
                        <img src={poseidon} alt="1" />
                        <img src={zeus} alt="1" />
                        <img src={athena} alt="1" />
                    </div>
                </div>
                <div className="m-janus__option-label">d)</div>
                <div className="m-janus-wrapper">
                    <div className="m-janus-row">
                        <img src={athena} alt="1" />
                        <img src={zeus} alt="1" />
                        <img src={lyre} alt="1" />
                        <img src={poseidon} alt="1" />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
